import { getStorageItem } from "./utils";
import moment from "moment";

// Start Surepass e-KYC Section
export const buildGenerateOtpPartnerPayload = ({ aadhaar_number, mobile }) => {
  return {
    aadhaar: aadhaar_number,
    mobile,
    consent: "Y",
    dob: getStorageItem("dob"),
    uid: 1,
  };
};

export const buildVerifyOtpPartnerPayload = (
  { aadhaar_number, clientId, mobile, otp, uid = 1 },
  checksum
) => {
  return {
    aadhaar: aadhaar_number,
    checksum,
    clientId,
    dob: getStorageItem("dob"),
    mobile,
    otp,
    uid,
  };
};

export const buildGenerateAadhaarPayload = () => {
  return {
    oid: Number(getStorageItem("oid")),
  };
};

export const buildCompleteAddress = (data) => {
  const address = `${data.data?.address?.house} ${data.data?.address?.street} ${data.data?.address?.loc} ${data.data?.address?.vtc} ${data.data?.address?.subdist} ${data.data?.address?.dist} ${data.data?.address?.state} ${data.data?.zip}`;

  return address.replace(/\s+/g, " ").trim();
};

export const parseEkycPartnerResponse = (data) => {
  const address = buildCompleteAddress(data);
  const fatherName = data.data.care_of ?? "";

  return {
    userName: data.data.full_name ? data.data.full_name : "NA",
    userDob: data.data.dob ? data.data.dob : "NA",
    userAddress: address ? address : "NA",
    userGender: data.data.gender ? getGenderData(data.data.gender) : "NA",
    pincode: data.data.zip ? data.data.zip : "NA",
    country: data.data.address.country ? data.data.address.country : "NA",
    fatherName: fatherName ? sanitizeFatherName(fatherName) : "",
  };
};
// End Surepass e-KYC Section

// Start Perfios e-KYC Section
export const buildGenerateOtpPayload = ({ aadhaar_number }) => {
  return {
    aadhaarNo: aadhaar_number,
    cid: Number(getStorageItem("cid")),
    consent: "Y",
    dob: getStorageItem("dob"),
    oid: Number(getStorageItem("oid")),
  };
};

export const buildVerifyOtpPayload = (
  { aadhaar_number, accessKey, otp },
  checksum
) => {
  return {
    aadhaarNo: aadhaar_number,
    checksum,
    cid: Number(getStorageItem("cid")),
    dob: getStorageItem("dob"),
    oid: Number(getStorageItem("oid")),
    otp,
    otp_access_token: accessKey,
  };
};

export const parseEkycResponse = (data) => {
  const fatherName = data.data.result.dataFromAadhaar.fatherName ?? "";

  return {
    userName: data.data.result.dataFromAadhaar.name
      ? data.data.result.dataFromAadhaar.name
      : "NA",

    userDob: data.data.result.dataFromAadhaar.dob
      ? data.data.result.dataFromAadhaar.dob
      : "NA",

    userAddress: data.data.result.dataFromAadhaar.address.combinedAddress
      ? data.data.result.dataFromAadhaar.address.combinedAddress
      : "NA",

    userGender: data.data.result.dataFromAadhaar.gender
      ? getGenderData(data.data.result.dataFromAadhaar.gender)
      : "NA",

    pincode: data.data.result.dataFromAadhaar.address.splitAddress.pincode
      ? data.data.result.dataFromAadhaar.address.splitAddress.pincode
      : "NA",

    country: data.data.result.dataFromAadhaar.address.splitAddress.country
      ? data.data.result.dataFromAadhaar.address.splitAddress.country
      : "NA",

    fatherName: fatherName ? sanitizeFatherName(fatherName) : "",
  };
};
// End Perfios e-KYC Section

// Start Common e-KYC Section
export const buildAdditionalCustomerPayload = () => {};

export const buildUpdateCustomerPayload = ({
  userName: name,
  userDob,
  userGender: gender,
  fatherName,
  userAddress: address,
  pincode,
  country,
  aadhaar = "",
}) => {
  return {
    cid: Number(getStorageItem("cid")),
    name,
    dob: moment(userDob).format("DD/MM/YYYY"),
    gender,
    fatherName,
    address,
    pincode,
    country,
    lang: 1,
    aadhaar,
  };
};

export const getGenderData = (gender) => {
  if (gender == "M") {
    return "Male";
  } else if (gender == "F") {
    return "Female";
  } else {
    return gender;
  }
};

export const isBlankEkycData = ({ userName, userDob, userGender }) => {
  return !userName || !userDob || !userGender;
};

export const sanitizeFatherName = (fatherName) => {
  const splitFatherName = fatherName.split(":");
  fatherName =
    splitFatherName.length > 1 ? splitFatherName[1] : splitFatherName[0];
  fatherName = fatherName.trim();
  localStorage.setItem("fatherName", fatherName);

  return fatherName;
};

export const maskAadhaarNumber = (aadhaar) => {
  if (!aadhaar || aadhaar.length !== 12) return aadhaar;
  return "XXXXXXXX" + aadhaar.slice(-4);
};
// End Common e-KYC Section
